
import React, { Component } from 'react';
import {
  CardBody,
  ListGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table
} from 'reactstrap';
import BrandService from "../../services/brandService";
import CompanyService from "../../services/companyService";
import ChannelService from "../../services/channelService";
import PlaylistService from "../../services/playlistService";

let brandService = new BrandService();
let companyService = new CompanyService();
let channelService = new ChannelService();
let playlistService = new PlaylistService();

class Search extends Component {

  constructor(props) {
    super(props);
    this.state = {
      active: 1,
      pageStart: 1,
      pageStartMax: 10,
      orderBy: null,
      order: 'ASC',
      data: this.props.data
    };
    this.changeActive = this.changeActive.bind(this);
    this.orderColumn = this.orderColumn.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.data) {
      return { active: 1, data: nextProps.data };
    }
    return null;
  }
  changeActive(index) {
    this.setState({ active: index });
  }
  changeActiveFirst() {
    this.setState({ active: 1, pageStart: 1, pageStartMax: 10 });
  }
  changeActiveLast(pages) {
    const base = Math.trunc(pages/10)*10;
    this.setState({ active: pages, pageStart: base+1, pageStartMax: base+10 });
  }
  changePager(pager, pagerMax) {
    this.setState({active: pager, pageStart: pager, pageStartMax: pagerMax });
  }  
  orderColumn(name){
    if(this.state.orderBy === null || name !== this.state.orderBy){
      this.setState({orderBy: name, order: 'ASC'});
    }else if(this.state.orderBy === name && this.state.order === 'ASC'){
      this.setState({order: 'DESC'});
    }else if(this.state.orderBy === name && this.state.order === 'DESC'){
      this.setState({orderBy: null, order: 'ASC'});
    }
  }
  addActive(value, pages, active) {
    let total = value + active;
    if (total > pages || total < 1) return;
    this.setState({ active: this.state.active + value });
  }
  searchId(list, id) {
    return list.find(x => x.id === id);
  }


  render() {
    let {
      data,
      ObjectTemplate,
      length,
      Empty,
      loading,
      Load,
      table,
      Thead,
      removePagination,
      bordered,
      striped,
      companies,
      brands,
      channels,
      playlists,
      zones
    } = this.props;
    let auxData = JSON.parse(JSON.stringify(data));


    if(this.state.orderBy !== null) {
      for (let i = 0; i < auxData.length; i++) {
        switch (this.state.orderBy){
          case 'companyId':
            if(auxData[i].companyId !== null && auxData[i].companyId !== undefined){
              const obj = this.searchId(companies, auxData[i].companyId);
              auxData[i].companyId = obj ? obj.name : 'No asignado';
            } else {
              auxData[i].companyId = 'No asignado';
            }
            break;
          case 'channelId':
            if(auxData[i].channelId !== null && auxData[i].channelId !== undefined){
              const obj = this.searchId(channels, auxData[i].channelId);
              auxData[i].channelId = obj ? obj.name : '-';
            } else {
              auxData[i].channelId = '-';
            }
            break;
          case 'playlistMusicId':
            if(auxData[i].playlistMusicId !== null && auxData[i].playlistMusicId !== undefined){
              const obj = this.searchId(playlists, auxData[i].playlistMusicId);
              auxData[i].playlistMusicId = obj ? obj.name : '-';
            } else {
              auxData[i].playlistMusicId = '-';
            }
            break;
          case 'brandId':
            if(auxData[i].brandId !== null && auxData[i].brandId !== undefined){
              const obj = this.searchId(brands, auxData[i].brandId);
              auxData[i].brandId = obj ? obj.name : '-';
            } else {
              auxData[i].brandId = '-';
            }
            break;
          case 'zoneId':
            if(auxData[i].zoneId !== null && auxData[i].zoneId !== undefined){
              const obj = this.searchId(zones, auxData[i].zoneId);
              auxData[i].zoneId = obj ? obj.name : '-';
            } else {
              auxData[i].zoneId = '-';
            }
            break;
          case 'songName':
            auxData[i].songName = auxData[i].songName ? auxData[i].songName : 'No ha tocado ninguna canción';
            break;


        }
      }
    }

    //ORDER BY
    if(this.state.orderBy !== null) {
      let sortedField = {id: this.state.orderBy, order: this.state.order};
      auxData.sort(function (a, b) {
        if(a[sortedField.id] === undefined || a[sortedField.id] === null) a[sortedField.id] = '';
        if(b[sortedField.id] === undefined || a[sortedField.id] === null) b[sortedField.id] = '';
        if (a[sortedField.id].toLowerCase().trim() > b[sortedField.id].toLowerCase().trim()) {
          return sortedField.order === 'ASC' ? 1 : -1;
        }
        if (a[sortedField.id].toLowerCase().trim() < b[sortedField.id].toLowerCase().trim()) {
          return sortedField.order === 'ASC' ? -1 : 1;
        }
        // a must be equal to b
        return 0;
      });
    } else {
      auxData = this.state.data;
    }

    // get original data
    let arr = Array();
    for (let i = 0; i < auxData.length; i++) {
      for (let j = 0; j < data.length; j++) {
        if(auxData[i].id === data[j].id) {
          arr.push(data[j]);
        }
      }
    }

    if (!Empty) Empty = <div> No se han encontrado coincidencias </div>;
    if (!Load) Load = <div> Cargando... </div>;
    length = length || 10;
    
    let { active, pageStart, pageStartMax } = this.state;
    let pagination = [];
    let specialPagination = [];
    let pages = Math.ceil(arr.length / length);
    if (pages === 0) pages = 1;
    if (pages > 9) {
      
        
        if (pageStartMax > 10){
          pagination.push(
            <PaginationItem key="0">
              <PaginationLink tag="button" onClick={() => this.changeActiveFirst()}>
                1
              </PaginationLink>
            </PaginationItem>
          );
          pagination.push(
            <PaginationItem key="1">
              <PaginationLink tag="button" onClick={() => this.changePager(pageStart-10, pageStartMax-10)}>
              <i className="fa fa-arrow-left" aria-hidden="true" />
              </PaginationLink>
            </PaginationItem>
          );
        }
        
      for (let number = pageStart; number <= pageStartMax; number++) {
        if(number < pages){
          pagination.push(
            <PaginationItem active={number === active}>
              <PaginationLink
                tag="button"
                onClick={() => this.changeActive(number)}
              >
                {number}
              </PaginationLink>
            </PaginationItem>
          );
        }
        
      }
      if (active < ((Math.trunc(pages/10)*10)+1))
        pagination.push(
          <PaginationItem key="3">
            <PaginationLink tag="button" onClick={() => this.changePager(pageStart+10, pageStartMax+10)}>
            <i className="fa fa-arrow-right" aria-hidden="true" />
            </PaginationLink>
          </PaginationItem>
        );

      if (active !== pages){
        pagination.push(
          <PaginationItem key="4">
            <PaginationLink
              tag="button"
              onClick={() => this.changeActiveLast(pages)}
            >
              {pages}
            </PaginationLink>
          </PaginationItem>
        );
      }else{
        pagination.push(
          <PaginationItem key="4" active={true}>
            <PaginationLink
              tag="button"
            >
              {pages}
            </PaginationLink>
          </PaginationItem>
        );
      }
        
      // specialPagination.push(
      //   <PaginationItem key="5">
      //     <PaginationLink
      //       tag="button"
      //       onClick={() => this.addActive(-1, pages, active)}
      //     >
      //       <i className="fa fa-arrow-left" aria-hidden="true" />
      //     </PaginationLink>
      //   </PaginationItem>
      // );
      // specialPagination.push(
      //   <PaginationItem key="4">
      //     <PaginationLink
      //       tag="button"
      //       onClick={() => this.addActive(1, pages, active)}
      //     >
      //       <i className="fa fa-arrow-right" aria-hidden="true" />
      //     </PaginationLink>
      //   </PaginationItem>
      // );
    } else {
      for (let number = 1; number <= pages; number++) {
        pagination.push(
          <PaginationItem key={number} active={number === active}>
            <PaginationLink
              tag="button"
              onClick={() => this.changeActive(number)}
            >
              {number}
            </PaginationLink>
          </PaginationItem>
        );
      }
    }

    if (table) {
      Load = (
        <tr>
          <td> Cargando... </td>
        </tr>
      );
      Empty = (
        <tr>
          <td>No se han encontrado coincidencias</td>
        </tr>
      );
      return (
        <React.Fragment>
          <Table
            hover
            bordered={typeof bordered === "undefined" ? true : bordered}
            striped={typeof striped === "undefined" ? true : striped}
            responsive
            size="sm"
          >
            <Thead {...this.props} orderColumn = {this.orderColumn} />
            <tbody>
              {arr
                .slice(length * (active - 1), length * active)
                .map((e, i) => {
                  return (
                    <ObjectTemplate
                      {...this.props}
                      key={e.id ? e.id : i}
                      item={e}
                      viewButton={this.props.viewButton}
                    />
                  );
                })}
              {arr.length === 0 && !loading && Empty}
              {loading && arr.length === 0 && Load}
            </tbody>
          </Table>
          {!removePagination && (
            <div className="d-flex justify-content-around mt-2 mb-0">
              <Pagination>{pagination}</Pagination>
              {specialPagination.length > 0 && (
                <Pagination>{specialPagination}</Pagination>
              )}
            </div>
          )}
        </React.Fragment>
      );
    }
    return (
      <CardBody>
        <ListGroup>
          {arr.slice(length * (active - 1), length * active).map((e, i) => {
            return (
              <ObjectTemplate
                {...this.props}
                key={e.id ? e.id : i}
                item={e}
                viewButton={this.props.viewButton}
              />
            );
          })}
          {arr.length === 0 && !loading && Empty}
          {loading && arr.length === 0 && Load}
        </ListGroup>
        {!removePagination && (
          <div className="d-flex justify-content-around mt-2 mb-0">
            <Pagination>{pagination}</Pagination>
            {specialPagination.length > 0 && (
              <Pagination>{specialPagination}</Pagination>
            )}
          </div>
        )}
      </CardBody>
    );
  }
}

export default Search;
